"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addMinter = void 0;
const config_1 = require("../config/config");
const constants_1 = require("../constants");
const errorMessages_1 = require("../errorMessages");
const types_1 = require("../types");
/**
 * Add minting access for one id to a contract you own.
 * @param addMinterArgs {@link AddMinterArgs}
 * @returns contract call to be passed to @mintbase-js/sdk execute method
 */
const addMinter = (args) => {
    const { minterId, contractAddress = config_1.mbjs.keys.contractAddress } = args;
    if (contractAddress == null) {
        throw new Error(errorMessages_1.ERROR_MESSAGES.CONTRACT_ADDRESS);
    }
    return {
        contractAddress: contractAddress || config_1.mbjs.keys.contractAddress,
        args: {
            account_id: minterId,
        },
        methodName: types_1.TOKEN_METHOD_NAMES.ADD_MINTER,
        gas: constants_1.GAS,
        deposit: constants_1.ONE_YOCTO,
    };
};
exports.addMinter = addMinter;
//# sourceMappingURL=addMinter.js.map